<template>
    <div class="fileInput">
        <loading :active.sync="isLoading" :can-cancel="false" :background-color="'transparent'"></loading>
        <div class="uploader" @dragover.prevent @drop.prevent="onDrop">
            <span class="uploadMoji">ファイルをドロップしてアップロード </span>
            <span class="uploadMataMoji">または</span>
            <label class="fileSelectLabel">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="maskAlpha" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
                        <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#maskAlpha)">
                        <path  fill="#004EA2" d="M7 20C5.48333 20 4.1875 19.475 3.1125 18.425C2.0375 17.375 1.5 16.0917 1.5 14.575C1.5 13.275 1.89167 12.1167 2.675 11.1C3.45833 10.0833 4.48333 9.43333 5.75 9.15C6.16667 7.61667 7 6.375 8.25 5.425C9.5 4.475 10.9167 4 12.5 4C14.45 4 16.1042 4.67917 17.4625 6.0375C18.8208 7.39583 19.5 9.05 19.5 11C20.65 11.1333 21.6042 11.6292 22.3625 12.4875C23.1208 13.3458 23.5 14.35 23.5 15.5C23.5 16.75 23.0625 17.8125 22.1875 18.6875C21.3125 19.5625 20.25 20 19 20H13.5C12.95 20 12.4792 19.8042 12.0875 19.4125C11.6958 19.0208 11.5 18.55 11.5 18V12.85L9.9 14.4L8.5 13L12.5 9L16.5 13L15.1 14.4L13.5 12.85V18H19C19.7 18 20.2917 17.7583 20.775 17.275C21.2583 16.7917 21.5 16.2 21.5 15.5C21.5 14.8 21.2583 14.2083 20.775 13.725C20.2917 13.2417 19.7 13 19 13H17.5V11C17.5 9.61667 17.0125 8.4375 16.0375 7.4625C15.0625 6.4875 13.8833 6 12.5 6C11.1167 6 9.9375 6.4875 8.9625 7.4625C7.9875 8.4375 7.5 9.61667 7.5 11H7C6.03333 11 5.20833 11.3417 4.525 12.025C3.84167 12.7083 3.5 13.5333 3.5 14.5C3.5 15.4667 3.84167 16.2917 4.525 16.975C5.20833 17.6583 6.03333 18 7 18H9.5V20H7Z"/>
                    </g>
                </svg>
                <span class="uploadFileSelectMoji">ファイルを選択</span>
                <input class="fileSelect" type="file" multiple accept="image/*" @change="onFileChange" />
            </label>
        </div>

        <div v-if="innerFiles.length" class="fileList">
            <div v-for="(file, index) in innerFiles" :key="file.name + index" class="fileItem">
                <span class="fielNm">{{ file.name }}</span>
                <button class="btnDel" @click="removeFile(index)">
                    <!--<i class="fas fa-times"></i>-->
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                    </svg>
                </button>
            </div>
            <button class="btnClear" @click="clearAll">全て削除</button>
        </div>
    </div>
</template>

<script>
import imageCompression from 'browser-image-compression';
import Loading from "vue-loading-overlay";

export default {
    name: 'FileUploader',
    components: {
        Loading
    },
    props: {
        value: Array, // v-model
        filesMax: {
            type: Number,
            default: 0,
        },

        fileSizeMax: {
            type: Number,
            default: 0, // MB
        },

        accept: {
            type: String,
            default: 'image/*',
        },
    },

    data() {
        return {
            innerFiles: this.value || [],
            isLoading: false
        };
    },

    watch: {
        innerFiles(val) {
            this.$emit('input', val);
        },
        value(val) {
            this.innerFiles = val;
        },
    },

    methods: {
        onFileChange: async function(e) {
            const selectedFiles = Array.from(e.target.files);
            await this.addFiles(selectedFiles);
            e.target.value = '';
        },

        onDrop: async function(e) {
            const droppedFiles = Array.from(e.dataTransfer.files);
            await this.addFiles(droppedFiles);
        },

        addFiles: async function(newFiles) {
            try{
                this.isLoading = true;

                if (this.filesMax > 0){
                    const isOverLimit = (newFiles.length + this.innerFiles.length) > this.filesMax;
                    if (isOverLimit) {
                        alert(this.$i18n.t('common.messages.uploadFileLimitMsg', [this.filesMax]));
                        return;
                    }
                }

                for (let file of newFiles) {
                    if (!file.type.startsWith('image/')) continue;
                    const fileSize = file.size / 1024 / 1024;            
                    const isTooBig = fileSize > this.fileSizeMax;

                    if (isTooBig) {
                        alert(this.$i18n.t('common.messages.uploadFileSizeLimitMsg', [file.name, this.fileSizeMax]));
                        continue;
                    }
                    try {
                        const options = {
                            maxSizeMB: 1,
                            useWebWorker: true,
                        };
                        const compressedFile = await imageCompression(file, options);
                        console.log(file.name + ' 圧縮前のサイズ:', (file.size / 1024).toFixed(2), 'KB');
                        console.log(file.name + ' 圧縮後のサイズ:', (compressedFile.size / 1024).toFixed(2), 'KB');

                        compressedFile.preview = URL.createObjectURL(compressedFile);
                        this.innerFiles.push(compressedFile);
                    } catch (error) {
                        console.error('圧縮失敗:', error);
                    }
                }
                
            }finally{
                this.isLoading = false;
            }
        },

        removeFile(index) {
            URL.revokeObjectURL(this.innerFiles[index].preview);
            this.innerFiles.splice(index, 1);
        },

        clearAll() {
            this.innerFiles.forEach(file => URL.revokeObjectURL(file.preview));
            this.innerFiles = [];
        },
  },

  beforeDestroy() {
      this.clearAll();
  },
};
</script>


<style scoped>
.fileInput {
    width:100%;
    #border: 2px dashed #3498db;
    border: 1px dashed #ccc;
    padding: 20px;
    border-radius: 6px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
}
.uploader {
    cursor: pointer;
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 5px;
    height: 100%;
    justify-content: center;
    width: 100%;
}
.uploadMoji {
    display: inline-block;
}
.uploadMataMoji {
    display: inline-block;
}
.uploadFileSelectMoji {
    display: inline-block;
}
.fileSelectLabel {
    width: 100%!important;
    align-items: center;
    text-align: center;
    background-color: transparent;
    cursor: pointer;
    font-weight: medium;
    gap: 5px;
    transition: background-color .1s linear
}
.fileSelectLabel input {
  display: none;
}
.fileList {
    width: 100%;
    margin-top: 1px;
    align-items: center;
    background-color: lightblue;
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-block-start: 5px;
    padding: 8px;
}
.fileItem {
    display: flex;
    align-items: center;
    margin-bottom: 1px;
    gap: 5px;
}
.btnDel {
    align-items: center;
    cursor: pointer;
    display: inline-flex;

    background: none;
    border: none;
    color: inherit;
    font: inherit;
    outline: none;
    padding: 0;
}
.btnDel>svg {
    block-size: 100%;
    inline-size: 100%;
    max-block-size: calc(clamp(.375rem, .2772727273rem + .3636363636vw, .5rem) * 2.5);
    max-inline-size: calc(clamp(.375rem, .2772727273rem + .3636363636vw, .5rem) * 2.5);
    fill: #ca0909;
}
.btnClear {
    margin-block-start: clamp(.375rem, .2772727273rem + .3636363636vw, .5rem);
    font-size: clamp(.6875rem, .6386363636rem + .1818181818vw, .75rem);
    min-inline-size: calc(clamp(.375rem, .2772727273rem + .3636363636vw, .5rem) * 6);
    padding: clamp(.375rem, .2772727273rem + .3636363636vw, .5rem);;
    background-color: #fff;
    color:  #ca0909;;
    box-shadow: 0 0 0 1px #ca0909;
    font-weight: 700;
}
</style>